import React from 'react'

const Footer = () => {
  return (
    <div className="footer">
      All &copy; Right Reserved by Verifium 
    </div>
  )
}

export default Footer